<template src="./template.html"></template>

<script>
import EmptyingTemplateDescription from '@/components/EmptyingTemplates/Description.vue'
import { emptyingIntervalOptions } from '@/components/mixins/constants'
import dateUtils from '@/components/mixins/dateUtils'

export default {
  name: 'EmptyingTemplateShowForm',
  mixins: [dateUtils],
  components: {
    EmptyingTemplateDescription,
  },
  props: {
    afterSubmit: Function,
    currentEmptyTemplate: Object,
  },
  data() {
    return {
      emptyingInterval: '',
      emptyTemplate: {},
      templateMode: 'edit',
    }
  },
  computed: {
    intervalOptions() {
      return emptyingIntervalOptions[this.$i18n.locale]
    },
    submitButtonDisabled() {
      return (
        this.emptyTemplate.reference_date == null ||
        this.emptyTemplate.reference_date == '' ||
        this.emptyingInterval === null
      )
    },
  },
  methods: {
    async submitEmptyingTemplate() {
      this.emptyTemplate.repeat_interval = this.emptyingInterval === 'once' ? null : this.emptyingInterval
      this.emptyTemplate.repeat_type = this.emptyingInterval === 'once' ? 'once' : 'recurring'
      this.afterSubmit(this.emptyTemplate)
    },
  },
  mounted() {
    this.emptyingInterval =
      this.currentEmptyTemplate.repeat_type === 'once' ? 'once' : this.currentEmptyTemplate.repeat_interval
    this.emptyTemplate = { ...this.currentEmptyTemplate }
  },
}
</script>
<style lang="scss" src="./styles.scss" scoped />
